import palette from '../../../../theme/palette';

export default () => ({
  filterInput: {
    width: '100%',
    '& label': {
      color: 'rgba(0, 0, 0, 0.6)',
      fontSize: '0.6rem',
      '@media (min-width: 1200px)': {
        fontSize: '1rem',
      },
    },
  },
  buttonClearFilter: {
    marginRight: '1rem',
  },
  searchIcon: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
  summaryWrapper: {
    display: 'flex',
    gap: '16px',
    marginBottom: '16px',
  },
  summaryCard: {
    flex: 1,
    padding: '20px 24px',
    borderRadius: '4px',
    backgroundColor: palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    boxShadow: '0px 1px 3px rgba(0,0,0,0.12)',
  },
  summaryCount: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1,
  },
  summaryLabel: {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    color: palette.text.secondary,
    marginTop: '4px',
  },
  countPendente: {
    color: palette.secondary.main,
  },
  countAprovado: {
    color: palette.success.main,
  },
  countRejeitado: {
    color: palette.danger.main,
  },
});

export const PendenciasTableRowStyles = {
  root: {
    width: '100%',
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableRow: {
    backgroundColor: palette.background.default,
    width: '100%',
    display: 'table',
    height: '72px',
  },
  tableCell: {
    fontSize: '14px',
    lineHeight: '20px',
    color: palette.text.secondary,
  },
  tr: {
    height: '72px',
  },
  cnpjCaption: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '0.875rem',
    color: palette.text.disabled,
  },
  statusChip: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '0.75rem',
    fontWeight: 500,
    gap: '6px',
  },
  statusAguardando: {
    backgroundColor: '#E3F2FD',
    color: '#1565C0',
  },
  statusAprovada: {
    backgroundColor: '#E8F5E9',
    color: palette.success.dark,
  },
  statusRecusada: {
    backgroundColor: '#FFEBEE',
    color: palette.danger.main,
  },
  statusPendencia: {
    backgroundColor: '#FFF3E0',
    color: palette.secondary.main,
  },
  statusValidacaoInterna: {
    backgroundColor: '#EDE7F6',
    color: '#4527A0',
  },
};
